import { z } from 'zod/v4';

export const jobTraceIdResponseSchema = z.object({
  jobTraceId: z.string(),
});

export type JobTraceIdResponse = z.infer<typeof jobTraceIdResponseSchema>;
